<template>
  <el-input
    v-model="inputValue"
    type="text"
    clearable
    :readonly="isReadonlyNow"
    :placeholder="placeholder"
    class="filter-input"
    :suffix-icon="inputValue.length ? '' : 'el-icon-right'"
    :disabled="isDisable || requestStatus"
    @clear="clearInput"
    @focus="$emit('clicked')"
    @change="toTop"
  />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'InputFilter',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    actionName: {
      type: String,
      default: ''
    },
    defaultStoreValue: {
      type: [Array, Object, Number],
      default: null
    },
    isReadonlyNow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },

  computed: {
    ...mapGetters({
      requestStatus: 'search/getRequestStatus'
    }),
    storeAction() {
      return this.actionName ? this.actionName : 'search/DEFAULT_INPUT_RESET'
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.inputValue = String(val)
      }
    }
  },
  methods: {
    clearInput() {
      this.inputValue = ''
      //  not used mapActions because they load earlier then prop with mutation name
      this.$store.dispatch(`${this.storeAction}`, this.defaultStoreValue)
      if (this.storeAction === 'search/SET_SCHEDULE') {
        this.$bus.$emit('clear.schedule')
      }
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-input {
  width: 100%;
}
</style>
